import {useLocation} from "react-router-dom"
import React from "react"

import {Search} from "@indebted/components/Search"

function CustomerError({error}: {error: any}) {
	const location = useLocation()
	const search = new URLSearchParams(location.search)

	return <Search value={search.get("q")} error={error} />
}

export {CustomerError}
